<div class="vl"></div>
<ion-buttons class="close" slot="primary">
  <ion-button class="btn-round" (click)="dismiss()">
    <ion-icon slot="icon-only" name="close" size="small"></ion-icon>
  </ion-button>
</ion-buttons>
<div class="content">
  <div class="head">
    <img class="green" src="assets/img/icon-chat.svg" />
    <img class="white" src="assets/img/icon-chat-white.svg" />
    <span>{{'__VIDEOCHAT_CHAT_HEADER__' | translate}}</span>
  </div>

  <div class="contents">
    <div id="message-wrap" class="chat-container message-wrap">
      <div *ngFor="let data of messageList; let i = index" class="message"
           [ngClass]="{right : data.from === userType, left : data.from !== userType}">
        <div class="user-img">
          <img *ngIf="data.from === userType" src="assets/img/icon-user-circle-purple.svg" />
          <img *ngIf="data.from !== userType" src="assets/img/icon-user-circle-gray.svg" />
        </div>
        <div class="msg-detail">

          <div class="msg-content">
            <span class="triangle"></span>
            <p class="text">{{data.message}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="add-notes">
      <ion-input required #chat_input class="title" placeholder="{{'__VIDEOCHAT_CHAT_TYPING_PLACEHOLDER__' | translate}}" [(ngModel)]="message"
        (keyup.enter)="sendMessage()" (ionFocus)="onFocus()"></ion-input>
      <button class="btn-round btn-round-black" (click)="sendMessage()"><img src="assets/img/icon-send.svg"></button>
    </div>
  </div>
</div>
